// extracted by css-extract-rspack-plugin
export default {"spaceApplyBox":"spaceApplyBox-RQNm02"};